<template>
  <div class="provides">
    <div class="learn-more">
      <div class="logo">
        <div class="logo-text">
          <div class="logo-name">Alchemy Pay, Inc.</div>
          <div class="logo-sub">United States Corporate Website</div>
          <div class="logo-sub">NMLS ID 2449570</div>
        </div>
        <div class="incorporated">
          Alchemy Pay, Inc. is the U.S. Alchemy Pay entity and is currently pre-operational. It does not accept customers or provide on-ramp, off-ramp, money transmission, or
          digital financial asset services in the United States, including California. Any future services will be subject to required licensing and regulatory approvals. Services
          offered by other Alchemy Pay entities outside the United States are not provided through this website.
        </div>
      </div>
      <div class="other">
        <div class="products">
          <ul>
            <li class="title">Products</li>
            <li class="link-name" @click="goHome">On-Ramp</li>
            <li class="link-name" @click="goHome">Off-Ramp</li>
          </ul>
        </div>
        <div class="products contact-us">
          <ul>
            <li class="title">Contact us</li>
            <li>
              <a class="email" href="mailto:info.us@alchemypay.org">info.us@alchemypay.org</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="canvas-bg">
      <canvas class="isLoaded" id="gradient-canvas1"></canvas>
    </div>
  </div>
</template>
<script>
import Gradient from "@/tool/Gradient.js";

export default {
  data() {
    return {
      gradient: null, // 渐变背景类名
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    // 初始化动态背景
    initGradient(id) {
      this.gradient = new Gradient();
      this.gradient.initGradient(id);
    },
  },
  mounted() {
    this.initGradient("#gradient-canvas1");
  },
  destroyed() {
    this.gradient.pause();
  },
  created() {},
};
</script>
<style lang="scss" scoped>
#gradient-canvas {
  --gradient-color-1: #1cbaf7;
  --gradient-color-2: #1cbaf7;
  --gradient-color-3: #1509f9;
  --gradient-color-4: #961aee;
  opacity: 0;
  // filter: blur(1px);
  // -webkit-filter: blur(1px);
}
#gradient-canvas.isLoaded {
  opacity: 1;
  transition: opacity 0.5s ease-in 50ms;
}
#gradient-canvas1 {
  --gradient-color-1: #1cbaf7;
  --gradient-color-2: #1cbaf7;
  --gradient-color-3: #1509f9;
  --gradient-color-4: #961aee;
  opacity: 0;
}
#gradient-canvas1.isLoaded {
  opacity: 1;
  transition: opacity 0.5s ease-in 50ms;
  // pointer-events: none;
}
@media screen and (max-width: 1180px) {
  .provides {
    position: relative;
    min-height: 400px;
    padding-bottom: 40px;
    overflow: hidden;
    .canvas-bg {
      width: 100%;
      position: absolute;
      top: 0;
      // left: 0;
      z-index: 0;
      canvas {
        width: 100%;
        height: auto;
      }
    }
    .learn-more {
      position: relative;
      z-index: 1;
      font-style: normal;
      color: #ffffff;
      max-width: calc(100% - 48px);
      margin: 0 auto;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      .logo {
        .logo-text {
          margin-bottom: 20px;
          .logo-name {
            font-family: "Bold";
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            color: #ffffff;
          }
          .logo-sub {
            font-family: "Regular";
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            color: rgba(255, 255, 255, 0.85);
          }
        }
        .incorporated {
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #ffffff;
        }
        .us-Licenses {
          margin-top: 30px;
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .other {
        margin-top: 40px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        .products {
          ul {
            li {
              font-family: "Regular";
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              color: #ffffff;
              margin-bottom: 10px;
              cursor: pointer;
            }
            li.title {
              font-family: "Bold";
              font-style: normal;
              font-weight: 700;
              font-size: 18px;
              color: #ffffff;
              cursor: auto;
            }
          }
        }
        .contact-us {
          ul {
            li {
              a {
                color: #3dfff3;
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1180px) and (max-width: 10000px) {
  .provides {
    position: relative;
    min-height: 300px;
    padding-bottom: 40px;
    overflow: hidden;
    .canvas-bg {
      width: 100%;
      position: absolute;
      top: 0;
      // left: 0;
      z-index: 0;
      canvas {
        width: 100%;
        height: auto;
      }
    }
    .learn-more {
      position: relative;
      z-index: 1;

      font-style: normal;
      color: #ffffff;
      max-width: calc(1440px - 130px - 130px);
      margin: 0 auto;
      margin-top: 60px;
      display: flex;
      // justify-content: space-between;
      .logo {
        width: 660px;
        .logo-text {
          margin-bottom: 24px;
          .logo-name {
            font-family: "Bold";
            font-weight: 700;
            font-size: 22px;
            line-height: 28px;
            color: #ffffff;
          }
          .logo-sub {
            font-family: "Regular";
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: rgba(255, 255, 255, 0.85);
          }
        }
        .incorporated {
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          color: #ffffff;
          max-width: 656px;
        }
        .us-Licenses {
          margin-top: 30px;
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .other {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        margin-left: 80px;
        flex: 1;
        .products {
          ul {
            li {
              font-family: "Regular";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #ffffff;
              margin-bottom: 24px;
              cursor: pointer;
            }
            li.title {
              font-family: "Bold";
              font-style: normal;
              font-weight: 700;
              font-size: 18px;
              line-height: 24px;
              color: #ffffff;
              margin-bottom: 32px;
              cursor: auto;
            }
          }
        }
        .link-name:hover {
          text-decoration: none;
          text-decoration: underline;
        }
        .contact-us {
          ul {
            li {
              a {
                color: #3dfff3;
              }
              a:hover {
                text-decoration: none;
                border-bottom: 1px solid #3dfff3;
              }
            }
          }
        }
      }
    }
  }
}
</style>
